var ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

/** A component that displays a list of files. */
function FileList(params) {
  if (params === undefined) {
    throw 'Error: FileList component requires parameters';
  } else if (params.fileList === undefined) {
    throw 'Error: The parameter fileList is required.';
  }

  this.fileList = params.fileList;
  // State to determine if we should show loading icon.
  this.isRemoving = ko.observable(false);
  // If no upload callback is provided we will use a noop function.
  this.removeFileCallback = params.removeFileCallback || function() {};
  this.removeFileUrl = params.removeFileUrl;
  this.isAbleToRemoveFile = ko.observable(params.removeFileUrl !== undefined);

  // Listen to an observable if remove should be disabled (empty observable so that the subscribe
  // won't produce an error).
  this.removeIsDisabled = params.removeDisabled || ko.observable(false);
  this.removeIsDisabled.subscribe(function(val) {
    if (val) {
      this.isAbleToRemoveFile(false);
    } else {
      this.isAbleToRemoveFile(params.removeFileUrl !== undefined);
    }
  }, this);

  if (this.removeIsDisabled()) {
    this.isAbleToRemoveFile(false);
  }

  // Variables to be passed to message component.
  this.type = ko.observable('is-error');
  // Feedback message from the remove API call.
  this.removeFeedback = ko.observable('');
  this.isMessageOpen = ko.observable(false);
}

FileList.prototype.removeFile = function(file, index) {
  var self = this,
    tmpFileList = self.fileList();

  self.isRemoving(true);
  self.removeFeedback('');
  self.isMessageOpen(false);

  APIHelper.QcDelete(
    self.removeFileUrl + file.fileId,
    {},
    function(response) {
      tmpFileList.splice(index, 1);
      self.fileList(tmpFileList);
      self.fileList.valueHasMutated();
      self.type('is-success');
      self.removeFeedback('Sletting av "' + file.name + '" var vellykket.');
      self.isRemoving(false);
      self.isMessageOpen(true);
      self.removeFileCallback(response);
    },
    function(error) {
      self.type('is-error');
      self.removeFeedback(
        'Det skjedde noe galt ved sletting av "' + file.name + '".'
      );
      self.isRemoving(false);
      self.isMessageOpen(true);
      self.removeFileCallback(error);
    }
  );
};

module.exports = FileList;
